import { InputCurrency } from "@/components/input-currency/InputCurrency";
import { AppColors } from "@/styles/colors";
import { Field, Text } from "@chakra-ui/react";
import { Control, FieldValues } from "react-hook-form";

interface Props {
  name: string;
  label: string;
  control: Control<FieldValues>;
  disabled?: boolean;
  prefix?: string;
}

export const CurrencyFormField = ({
  name,
  label,
  control,
  disabled,
  prefix = "U$S ",
}: Props) => (
  <Field.Root>
    <Field.Label>
      <Text fontWeight={600} fontSize="13px" color={AppColors.GRAY_TEXT}>
        {label}
      </Text>
    </Field.Label>
    <InputCurrency
      name={name}
      control={control}
      disabled={disabled}
      placeholder="Ingresar"
      prefix={prefix}
      height="40px"
    />
  </Field.Root>
);
